import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CheckCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CheckCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CheckCircleTwoTone);